// THE ONLY FRONTEND FILE EMERGENT MAY EDIT: adapt these two lines to how the site already calls its backend while logged in.
export const API_BASE = process.env.REACT_APP_BACKEND_URL;
export const authFetch = (path, opts = {}) =>
  fetch(`${API_BASE}${path}`, { credentials: "include", headers: { "Content-Type": "application/json", ...(opts.headers || {}) }, ...opts });
